import { Dropdown, DropdownToggle } from 'reactstrap';
import classNames from 'classnames';

function TempFilter(props) {
    const textValue = props.value?.label ? props.value.label : props.value;

    const toggle = () => {};

    return (
        <Dropdown isOpen={false} toggle={toggle} direction="down">
            <DropdownToggle tag="div" className={classNames('searchable-list-filter-menu-item-button', { 'has-value': true })}>
                <div className="searchable-list-filter-menu-item-button-text">
                    <div className="searchable-list-filter-menu-item-button-label">{props.label}</div>
                    <div className="searchable-list-filter-menu-item-button-value">{textValue}</div>
                    <div
                        className="searchable-list-filter-menu-item-button-remove"
                        onClick={e => {
                            e.stopPropagation();
                            props.context.removeTempFilter(props.name);
                        }}
                    >
                        &times;
                    </div>
                </div>
            </DropdownToggle>
        </Dropdown>
    );
}

export default TempFilter;
